module.exports = __webpack_public_path__ + "img/edit-icon.2ecbf288.svg";